import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import BootstrapVue, {BootstrapVueIcons} from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import {store} from './store';
import VueFeather from 'vue-feather';
import Toasted from 'vue-toasted';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import {VueReCaptcha} from 'vue-recaptcha-v3'
import HighchartsVue from 'highcharts-vue'
import Emoji from 'emoji-picker-element';
import {TreeView} from "@bigplay/vue-tree-view-v2";
import "@bigplay/vue-tree-view-v2/dist/style.css"
import PxCard from './components/Pxcard.vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import {registerLicense} from '@syncfusion/ej2-base';

Vue.config.devtools = true;

Vue.component(PxCard.name, PxCard)
Vue.use(Toast)
Vue.component('TreeView', TreeView)


// Import Theme scss
import "vue-select/dist/vue-select.css";
import './assets/scss/app.scss'
import {ValidationProvider} from "vee-validate";
import {extend} from 'vee-validate';
import {required, email, min, min_value, max, max_value} from 'vee-validate/dist/rules';
import {KanbanPlugin} from "@syncfusion/ej2-vue-kanban";

extend('email', email);
extend('min', min);
extend('min_value', min_value);
extend('required', {
    ...required,
    message: 'This field is required'
});
Vue.use(KanbanPlugin);
Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(Toasted);
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(VueReCaptcha, {siteKey: '6LdEv0wnAAAAAGwgU1qE3z97nIn3mjnwvNPlCEih'})
Vue.use(HighchartsVue)
Vue.component('EmojiPicker', Emoji)


document.addEventListener('wheel', function (e) {
    if (e.target && e.target.type === 'number') {
        e.target.blur()
    }
}, { passive: true })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
/*
* @todo проставить как придет ключ
* не сработало попросить другого
* */
registerLicense('ВАШ_ЛИЦЕНЗИОННЫЙ_КЛЮЧ')